import styled from 'styled-components';

const KeyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const Circle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.backdrop.light};
`;

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.palette.backdrop.light};
  padding: ${({ theme }) => theme.spacing(2, 3)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  outline: 2px solid ${({ theme }) => theme.palette.backdrop.dark};
`;

const TooltipLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 180px;
`;

export { TooltipContainer, KeyContainer, Circle, TooltipLabel };
